import api from '../../../../services/api';
import { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import { useForm } from "react-hook-form";
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import PageContainer from '../../../../common/components/PageContainer';
import useAlerta from '../../../../common/components/useAlerta';
import AppSnackbar from '../../../../common/components/AppSnackbar';

function EPISaida() {
    const [item, setItem] = useState({});
    const { id } = useParams();
    const [anexoData, setAnexoData] = useState(null);
    const { alerta, mostrarAlerta, fecharAlerta } = useAlerta();
    const { register, handleSubmit, reset, setValue } = useForm();
    const [funcionarios, setFuncionarios] = useState([]);
    const [funcionarioSelecionado, setFuncionarioSelecionado] = useState("");

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            convertToBase64(file);
        }
    };

    const convertToBase64 = (file) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
            setAnexoData(reader.result);
        };
        reader.onerror = (error) => {
            console.error('Erro ao converter a imagem para Base64:', error);
        };
    };

    const handleImprimirFicha = async () => {
        if (!funcionarioSelecionado) {
            mostrarAlerta('Selecione um funcionário!', 'error');
            return;
        }

        try {
            const response = await api.get(`/epi/${id}/pdf`, {
                params: { idRecebedor: funcionarioSelecionado },
                responseType: 'blob',
            });

            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);

            window.open(url, '_blank');
        } catch (error) {
            console.error('Erro ao gerar a ficha PDF:', error);
            mostrarAlerta('Erro ao gerar a ficha PDF!', 'error');
        }
    };

    useEffect(() => {
        async function fetchDataFuncionarios() {
            try {
                const response = await api.get(`/funcionario/lista`);
                setFuncionarios(response.data);
            } catch (error) {
                console.error('Erro ao buscar funcinarios:', error);
            }
        }
        fetchDataFuncionarios();
    }, []);

    const onSubmit = async (data) => {
        const formData = {
            acao: "Saida",
            idRecebedor: funcionarioSelecionado,
            ...data,
            foto: anexoData,
        };

        try {
            await api.put(`/epi/${id}/subtract`, formData);
            mostrarAlerta('Saída realizada com sucesso!', 'success');
            setTimeout(() => {
                window.location.href = `/epi/${id}`;
            }, 1500);
        } catch (error) {
            mostrarAlerta('Erro ao realizar a saída!', 'error');
        }
        setTimeout(fecharAlerta, 3000);
    };

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await api.get(`/epi/${id}`);
                setItem(response.data);
                reset(response.data);
                const hoje = new Date().toISOString().split('T')[0];
                setValue("data", hoje);
            } catch (error) {
                console.error('Erro ao buscar o item:', error);
            }
        }

        fetchData();
    }, [id, reset, setValue]);

    return (
        <PageContainer sx={{ maxWidth: 700 }}>
            <Paper component="form" onSubmit={handleSubmit(onSubmit)} sx={{ p: { xs: 2, sm: 4 } }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                    <Typography variant="h5" sx={{ color: 'primary.main', fontWeight: 600 }}>
                        {item.nome}
                    </Typography>
                    {item.foto && (
                        <Box component="img" src={`data:image/jpeg;base64,${item.foto}`} alt="Item" sx={{ height: 40, borderRadius: 1 }} />
                    )}
                </Box>

                <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                        <TextField {...register("quantidade")} label="Quantidade" type="number" required fullWidth />
                    </Grid>
                    <Grid item xs={12} sm={8}>
                        <TextField {...register("descricao")} label="Descrição" required fullWidth />
                    </Grid>
                    <Grid item xs={12} sm={8}>
                        <TextField
                            select
                            label="Funcionário Recebedor"
                            value={funcionarioSelecionado}
                            onChange={(e) => setFuncionarioSelecionado(e.target.value)}
                            required
                            fullWidth
                        >
                            <MenuItem value="">Selecione um funcionário</MenuItem>
                            {funcionarios.map(funcionario => (
                                <MenuItem key={funcionario.id} value={funcionario.id}>
                                    {funcionario.nome}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextField {...register("data")} label="Data da saída" type="date" InputLabelProps={{ shrink: true }} required fullWidth />
                    </Grid>
                    <Grid item xs={12}>
                        <Button variant="outlined" component="label" fullWidth>
                            Foto da assinatura
                            <input
                                {...register("foto")}
                                type="file"
                                capture
                                accept="image/*"
                                hidden
                                onChange={handleFileChange}
                            />
                        </Button>
                    </Grid>
                </Grid>

                <Stack direction="row" spacing={2} justifyContent="center" sx={{ mt: 4 }}>
                    <Button type="submit" variant="contained" color="secondary" size="large">
                        Realizar saída
                    </Button>
                    <Button variant="outlined" size="large" onClick={handleImprimirFicha}>
                        Imprimir ficha
                    </Button>
                </Stack>
            </Paper>

            <AppSnackbar alerta={alerta} onClose={fecharAlerta} />
        </PageContainer>
    );
}

export default EPISaida;
